import { DefaultState, DropdownItem } from 'store/types';

export const READ_OCCUPANCY_RATE_FILTERS_REQUEST = 'READ_OCCUPANCY_RATE_FILTERS_REQUEST';
export const READ_OCCUPANCY_RATE_FILTERS_SUCCESS = 'READ_OCCUPANCY_RATE_FILTERS_SUCCESS';
export const READ_OCCUPANCY_RATE_FILTERS_FAILURE = 'READ_OCCUPANCY_RATE_FILTERS_FAILURE';

export interface OccupancyRateFilterData {
  dates: DropdownItem[];
}

export type OccupancyRateFiltersState = DefaultState & {
  contents?: OccupancyRateFilterData;
};

interface ReadOccupancyRateFiltersRequest {
  type: typeof READ_OCCUPANCY_RATE_FILTERS_REQUEST;
}

interface ReadOccupancyRateFiltersSuccess {
  type: typeof READ_OCCUPANCY_RATE_FILTERS_SUCCESS;
  contents: OccupancyRateFilterData;
}

interface ReadOccupancyRateFiltersFailure {
  type: typeof READ_OCCUPANCY_RATE_FILTERS_FAILURE;
}

export type OccupancyRateFiltersActionTypes =
  | ReadOccupancyRateFiltersRequest
  | ReadOccupancyRateFiltersSuccess
  | ReadOccupancyRateFiltersFailure;
